import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { requireAdmin } from "@/lib/admin.functions";

export const Route = createFileRoute("/_authenticated/_admin")({
  beforeLoad: async () => {
    const result = await requireAdmin();
    if (!result.isAdmin) throw redirect({ to: "/" });
    return { adminUserId: result.userId };
  },
  component: () => <Outlet />,
});
